module.exports = __webpack_public_path__ + "img/H_red.dde44b88.png";